import api from '@/lib/axios';

export interface CreateBranchData {
  companyId: string;
  name: string;
  address?: string;
  phone?: string;
}

export const sucursalesService = {
  async findByCompany(companyId: string) {
    const response = await api.get(`/branches/company/${companyId}`);
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/branches/${id}`);
    return response.data;
  },

  async create(data: CreateBranchData) {
    const response = await api.post('/branches', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateBranchData>) {
    const response = await api.patch(`/branches/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/branches/${id}`);
    return response.data;
  },

  async generateToken(id: string) {
    const response = await api.post(`/branches/${id}/generate-token`);
    return response.data;
  },
};
